export default __webpack_public_path__ + "static/media/goat_403.dd5ccfc1.svg";